export default "/images/cc7e528afaf6f93cb0ea2d9dd3241d47.avif";